module.exports = __webpack_public_path__ + "static/img/17069D_3_4_C_20210406_LC.af52f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17069D_3_4_C_20210406_LC.png
// module id = dZHI
// module chunks = 0